import { Link as RouterLink } from 'react-router-dom';

import PropTypes from 'prop-types';

import { Link } from '@mui/material';
import { useTheme } from '@mui/material/styles';

const StyledLink = ({ children, ...rest }) => {
  const theme = useTheme();
  return (
    <Link
      component={RouterLink}
      style={{ color: theme.palette.custom.link }}
      {...rest}
    >
      {children}
    </Link>
  );
};

StyledLink.propTypes = {
  children: PropTypes.oneOfType([
    PropTypes.instanceOf(Object),
    PropTypes.string,
  ]),
};

export default StyledLink;
